import React from 'react';
import {useEffect, useState} from "react";
import {Link,useParams} from "react-router-dom";
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BASE_URL} from "../../url";
import { FaMapMarker, FaAngleRight,  FaCamera, FaWhatsapp  } from 'react-icons/fa';
import placeholderImage from '../../images/placeholder.png';
import { Spinner } from 'react-bootstrap';
import { BiLogoWhatsapp } from "react-icons/bi";

function TrekPage() {
  const [trekDetails,setTrekDetails] = useState(null);
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetch(`${BASE_URL}/trekDetails/${id}`)
      .then(response => {
        response.json().then(trekDetails => {
          setTrekDetails(trekDetails);
          setLoading(false);
        });
      });
  }, []);
  
  let trekInfo;
  if(trekDetails != null) {
    trekInfo = trekDetails;
  }

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status" className='trekNameWhite'></Spinner>
      </div>
    ); 
  }

  if(trekInfo){
    return (
      <>
      <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
      <Card className='cardBody aboutTop'>
        <Card.Header className="cardBodyNew"><h4 className='fontColor-2'>{(trekInfo.trekName.toUpperCase())}</h4></Card.Header>
        <Card.Body className="cardBodyNew">
        <Card.Img
          variant="top"
          className='trekImage'
          src={trekInfo.thumbnailImage || placeholderImage}
          alt="Trek Thumbnail"
          loading="lazy"
        />
        <a href={`/gallery`} className="btn-get-started-gallery"><FaCamera  />&nbsp; VIEW MORE PHOTOS</a>
        
          <Card.Text className="cardBodyNew trekLine">{(trekInfo.trekDescription)}</Card.Text>
          
          <Card.Text className="cardBodyNew">
            <ol>
              <li className='trekLine'>Difficulty level : {(trekInfo.difficultyLevel)}</li>
              <li className='trekLine'>Trek Length : {(trekInfo.trekLength)} Kms in total</li>
              <li className='trekLine'>Altitude : {(trekInfo.altitude)} Meter</li>
              <li className='trekLine'>Minimum Age : {(trekInfo.minAge)} Years</li>
              <li className='trekLine'>Price : ₹{trekInfo.trekPrice.toLocaleString('en-IN')} per/head</li>
              <li className='trekLine'>Difficulty level : {(trekInfo.difficultyLevel)}</li>
              <li className='trekLine'>Number of Days :  {(trekInfo.numberOfDays)} Days</li>
              <li className='trekLine'>When :  {(new Date(trekInfo.startDate)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} To {(new Date(trekInfo.endDate)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</li>
            </ol>
          </Card.Text>
          
          
          <Card.Text className="cardBodyNew">
          <div className="trekSubHead marg-left">WHAT'S INCLUDED</div>
            <ol>
              {trekInfo.whatsIncluded.map((item, index) => (
                <li className='trekLine'>{item.whatsIncluded}</li>
              ))}
            </ol>
          </Card.Text>
          <Card.Text className="cardBodyNew">
          <div className="trekSubHead marg-left">WHAT'S NOT INCLUDED</div>
            <ol>
              {trekInfo.whatsNotIncluded.map((item, index) => (
                <li className='trekLine'>{item.whatsNotIncluded}</li>
              ))}
            </ol>
          </Card.Text>
          
            <Card.Text className="cardBodyNew">
            <div className="trekSubHead marg-left">THINGS TO CARRY</div>
            <ol>
              {trekInfo.thingsToCarry.map((item, index) => (
                <li className='trekLine'>{item.thingsToCarry}</li>
              ))}
            </ol>
            </Card.Text>
            
            <Card.Text className="cardBodyNew">
            <div className="trekSubHead marg-left">PICK UP POINT</div>
            <FaMapMarker/> &nbsp; <a href={(trekInfo.pickUpGmapLocation)} target='_blank'>{(trekInfo.pickUpLocation)}</a> <br/>
            </Card.Text>
            <a href={`https://api.whatsapp.com/send?text=Check this Trek that I found on Holla's Trekking Website, https://hollas-travel-booking-app.netlify.app/trekDetails/`+ trekInfo._id} className="btn-get-whatsapp" target='_blank'><FaWhatsapp className='wa-icon'/>&nbsp; SHARE ON WHATSAPP</a>
            <a href={`/bookTrek/`+trekInfo._id} className="btn-get-started">BOOK NOW</a>
        </Card.Body>
      </Card>
      </>
    )
  }
}

export default TrekPage
